import { useState } from "react";
import { ChevronDown } from "lucide-react";

const formatList = (value: unknown) =>
  Array.isArray(value)
    ? value.filter(Boolean).join(", ")
    : typeof value === "string"
      ? value
      : "";

const CourseFinderSection = ({ lead }: { lead: Record<string, any> }) => {
  const [expanded, setExpanded] = useState(false);
  const result = lead.courseFinderResult;
  if (
    !(
      result ||
      lead.courseFinderInterests?.length ||
      lead.preferredStudyLocations?.length
    )
  )
    return null;
  const answers = result?.answers || {};

  return (
    <div className="rounded-md border border-violet-200 bg-violet-50 p-2">
      <button
        type="button"
        onClick={() => setExpanded((value) => !value)}
        className="flex w-full items-center justify-between text-left font-bold text-violet-800 cursor-pointer"
      >
        <span>Course Finder</span>
        <ChevronDown
          className={`h-4 w-4 transition-transform ${expanded ? "rotate-180" : ""}`}
        />
      </button>
      {expanded && (
        <div className="mt-2 space-y-1 text-violet-900">
          <p>
            <span className="font-semibold">Interests:</span>{" "}
            {formatList(
              answers.courseFinderInterests || lead.courseFinderInterests,
            ) || "-"}
          </p>
          <p>
            <span className="font-semibold">Locations:</span>{" "}
            {formatList(
              answers.preferredStudyLocations || lead.preferredStudyLocations,
            ) || "-"}
          </p>
          {[
            ["Qualification", answers.qualification || lead.qualification],
            [
              "Estimated Result",
              answers.estimatedResult || lead.estimatedResult,
            ],
            ["Student Result", answers.studentResult || lead.studentResult],
            ["Pathway", answers.pathway || lead.pathway],
            ["Budget", answers.budget || lead.budget],
          ].map(([label, value]) => (
            <p key={label}>
              <span className="font-semibold">{label}:</span> {value || "-"}
            </p>
          ))}
          <div className="pt-2">
            <p className="font-semibold">Suggested Courses:</p>
            {result?.recommendations?.courses?.length ? (
              <ul className="mt-1 list-disc space-y-1 pl-5">
                {result.recommendations.courses.map(
                  (course: any, index: number) => (
                    <li key={`${course.name || course}-${index}`}>
                      <span className="font-medium">
                        {course.name || course}
                      </span>
                      {course.desc ? ` - ${course.desc}` : ""}
                    </li>
                  ),
                )}
              </ul>
            ) : (
              <p>-</p>
            )}
          </div>
          <div className="pt-2">
            <p className="font-semibold">Suggested Universities:</p>
            {result?.recommendations?.universities?.length ? (
              <ul className="mt-1 list-disc space-y-2 pl-5">
                {result.recommendations.universities.map(
                  (uni: any, index: number) => (
                    <li key={`${uni.name || uni}-${index}`}>
                      <span className="font-medium">{uni.name || uni}</span>
                      <span className="block text-xs">
                        {[uni.location, uni.type, uni.feeRange]
                          .filter(Boolean)
                          .join(" | ")}
                      </span>
                      {uni.reasons?.length ? (
                        <span className="block text-xs">
                          Reasons: {formatList(uni.reasons)}
                        </span>
                      ) : null}
                    </li>
                  ),
                )}
              </ul>
            ) : (
              <p>-</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default CourseFinderSection;
